import { Redirect, Switch, useRouteMatch } from "react-router-dom";

import { useAppState } from "@/components/AppStateProvider";
import AuthRoute from "@/components/AuthRoute";
import ReportsRouteGuard from "@/components/reports/ReportsRouteGuard";

import ReportDetail from "./ReportDetail";
import CustomerReportPrint from "./ReportPrint";
import Reports from "./Reports";
import { REPORTS_LIST_QUERY } from "./graphql/queries";

export default function CustomerReportsRoutes() {
  const match = useRouteMatch();
  const { userInfo } = useAppState();
  const user = userInfo?.user;

  return (
    <ReportsRouteGuard
      reportsQuery={REPORTS_LIST_QUERY}
      userEntitlements={user?.entitlements}
      skip={!user}
    >
      <Switch>
        <AuthRoute exact path={match.path} component={Reports} />
        <AuthRoute exact path={`${match.path}/:reportSlug/print`} component={CustomerReportPrint} />
        <AuthRoute exact path={`${match.path}/:reportSlug/:tab`} component={ReportDetail} />
        <Redirect from={`${match.path}/:reportSlug`} to={`${match.path}/:reportSlug/overview`} exact />
      </Switch>
    </ReportsRouteGuard>
  );
}
